import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { HavadesEnferadiPaths } from './HavadesEnferadiPaths';

const EnferadiEstelamPage = lazy(() => import('../../Estelam/Pages/EnferadiEstelamPage'));
const EnferadiBimehNamehDetailPage = lazy(() => import('../../Detail/Pages/EnferadiBimehNamehDetailPage'));
const ElhaghiyehSaderehDetailPage = lazy(
  () => import('../../ElhaghiyehSaderehDetail/Pages/ElhaghiyehSaderehDetailPage')
);
const ElhaghiyehHayeSaderehHadesehEnferadiPage = lazy(
  () => import('../../ElhaghiyehHayeSadereh/Pages/ElhaghiyehHayeSaderehHadesehEnferadiPage')
);

const HavadesEnferadiRoutes: IRoute[][] = [
  [
    {
      path: HavadesEnferadiPaths.BimehNameh.Estelam,
      component: EnferadiEstelamPage,
      needAuth: true,
    },
    {
      path: HavadesEnferadiPaths.BimehNameh.Detail,
      component: EnferadiBimehNamehDetailPage,
      needAuth: true,
    },
    {
      path: HavadesEnferadiPaths.BimehNameh.ElhaghiyehHayeSadereh,
      component: ElhaghiyehHayeSaderehHadesehEnferadiPage,
      needAuth: true,
    },
    {
      path: HavadesEnferadiPaths.BimehNameh.ElhaghiyehSaderehDetail,
      component: ElhaghiyehSaderehDetailPage,
      needAuth: true,
      parameters: ['gharardadBimehId'],
    },
  ],
];

export default HavadesEnferadiRoutes;
